export function demacronise(val: string) {
    if (!val) {
        return val;
    }

    return val
        .replace(/ā/g, "a")
        .replace(/ē/g, "e")
        .replace(/ī/g, "i")
        .replace(/ō/g, "o")
        .replace(/ū/g, "u")
        .replace(/Ā/g, "A")
        .replace(/Ē/g, "E")
        .replace(/Ī/g, "I")
        .replace(/Ō/g, "O")
        .replace(/Ū/g, "U")
        .replace(/[^a-zA-Z0-9. -_]/g, "");
}
